<template>
    <div>
        <app-card>
            <div class="d-flex justify-between align-left mb-4">
                <div>
                    <h4>CÁC TRƯỜNG HỢP BẤT THƯỜNG</h4>
                    <p class="fs-14 grey--text">Báo cáo các trường hợp bất thường trong hệ thống Internet</p>
                </div>


                <v-flex class="xs12 md2">
                    <v-btn color="primary" @click="exportToExcel" :loading="loading.export" dark>
                        <v-icon left>file_download</v-icon>
                        Xuất Excel
                    </v-btn>
                </v-flex>
            </div>

            <!-- Case 1 và 2 gộp lại: Cặp chính phụ có phòng báo trả phòng hoặc phòng có mạng trống -->
            <div class="mb-4">
                <h5 class="mb-3">1/ Cặp chính phụ có phòng báo trả phòng hoặc phòng có mạng trống</h5>
                <v-data-table :loading="loading.case1And2" :headers="headers" :items="case1And2MainData"
                    :rows-per-page-items="[10, 25, 50]" class="elevation-1">
                    <template #items="props">
                        <tr @click="props.item.has_pair_problem ? toggleExpandCase1And2(getItemKey(props.item)) : null" 
                            :style="props.item.has_pair_problem ? 'cursor: pointer;' : ''">
                            <td class="text-left">
                                <div class="d-flex align-center">
                                    <span>{{ props.item.user || '' }}</span>
                                    <v-icon v-if="props.item.has_pair_problem" small class="ml-2">
                                        {{ expanded_case1And2.includes(getItemKey(props.item)) ? 'expand_less' : 'expand_more' }}
                                    </v-icon>
                                </div>
                            </td>
                            <td>{{ props.item.room_id || '' }}</td>
                            <td>
                                <span :class="['v-badge', wifiTypeBadges[props.item.wifi_type].badge]">
                                    {{ wifiTypeBadges[props.item.wifi_type].text }}
                                </span>
                            </td>
                            <td>
                                <span :class="['v-badge', getStatusBadge(props.item)]">
                                    {{ getStatusText(props.item) }}
                                </span>
                            </td>
                            <td>{{ props.item.date_schedule_out ? formatDate(props.item.date_schedule_out) : '' }}</td>
                        </tr>
                        <!-- Hiển thị cặp wifi khi expanded -->
                        <template v-if="props.item.has_pair_problem && expanded_case1And2.includes(getItemKey(props.item))">
                            <tr v-for="pair in getCase1And2PairItems(props.item)" :key="pair._id || pair.room_id" 
                                class="auxiliary-row" style="background-color: #f5f5f5;">
                                <td class="text-left pl-4">
                                    <span class="text-muted">{{ pair.user || props.item.user || '' }}</span>
                                </td>
                                <td>{{ pair.room_id || props.item.room_id || '' }}</td>
                                <td>
                                    <span :class="['v-badge', wifiTypeBadges[pair.wifi_type || 'auxiliary'].badge]">
                                        {{ wifiTypeBadges[pair.wifi_type || 'auxiliary'].text }}
                                    </span>
                                </td>
                                <td>
                                    <span :class="['v-badge', getStatusBadge(pair)]">
                                        {{ getStatusText(pair) }}
                                    </span>
                                </td>
                                <td>{{ pair.date_schedule_out ? formatDate(pair.date_schedule_out) : '' }}</td>
                            </tr>
                        </template>
                    </template>
                    <template #no-data>
                        Chưa có thông tin
                    </template>
                </v-data-table>
            </div>

            <!-- Case 2: Giá khác mặc định -->
            <div class="mb-4">
                <h5 class="mb-3">2/ Các phòng có giá thu khách hàng khác với giá mặc định</h5>
                <v-data-table :loading="loading.case3" :headers="priceHeaders" :items="case3Data"
                    :rows-per-page-items="[10, 25, 50]" class="elevation-1">
                    <template #items="props">
                        <tr>
                            <td class="text-left">{{ props.item.user || '' }}</td>
                            <td class="text-left">{{ props.item.room_id || '' }}</td>
                            <td>
                                <span :class="['v-badge', wifiTypeBadges[props.item.wifi_type].badge]">
                                    {{ wifiTypeBadges[props.item.wifi_type].text }}
                                </span>
                            </td>
                            <td class="text-left">{{ formatCurrency(props.item.price) }}</td>
                            <td class="text-left">{{ formatCurrency(props.item.customer_price) }}</td>
                        </tr>
                    </template>
                    <template #no-data>
                        Chưa có thông tin
                    </template>
                </v-data-table>
            </div>
        </app-card>
    </div>
</template>

<script>
import api from "Api";
import moment from 'moment';

export default {
    name: "AbnormalCasesReport",
    data() {
        return {
            loading: {
                case1And2: false,
                case3: false,
                export: false
            },
            case1And2Data: [],
            case3Data: [],
            expanded_case1And2: [],
            headers: [
                { text: 'User', value: 'user', align: 'left   ' },
                { text: 'Phòng', value: 'room_id', align: 'left' },
                { text: 'Loại wifi', value: 'wifi_type', align: 'left' },
                { text: 'Tình trạng', value: 'status', align: 'left' },
                { text: 'Ngày trả phòng', value: 'date_schedule_out', align: 'left' }
            ],
            priceHeaders: [
                { text: 'User', value: 'user', align: 'left' },
                { text: 'Phòng', value: 'room_id', align: 'left' },
                { text: 'Loại wifi', value: 'wifi_type', align: 'left' },
                { text: 'Giá gói cước', value: 'price', align: 'left' },
                { text: 'Giá thu khách hàng', value: 'customer_price', align: 'left' },
            ],
            wifiTypeBadges: {
                'main': { text: 'Wifi chính', badge: 'success' },
                'auxiliary': { text: 'Wifi phụ', badge: 'info' },
                'private': { text: 'Wifi riêng', badge: 'warning' }
            },
            exportHeaders: [
                'User',
                'Phòng',
                'Loại wifi',
                'Tình trạng',
                'Ngày trả phòng',
                'Giá hiện tại',
                'Giá thu khách hàng',
                'Loại bất thường'
            ]
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            try {
                this.loading.case1And2 = true;
                this.loading.case3 = true;

                const response = await api.getAbnormalCases();

                if (response.status === 200) {
                    this.case1And2Data = response.data.case1And2 || [];
                    this.case3Data = response.data.case3 || [];
                } else {
                    console.error('Error loading abnormal cases:', response);
                    swal.fire('Lỗi', 'Không thể tải dữ liệu báo cáo', 'error');
                }
            } catch (error) {
                console.error('Error in loadData:', error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi tải dữ liệu', 'error');
            } finally {
                this.loading.case1And2 = false;
                this.loading.case3 = false;
            }
        },
        getStatusText(item) {
            if (!item.room_state_id) return 'MẠNG TRỐNG';
            if (item.date_schedule_out) return 'TRẢ PHÒNG';
            return 'Đang hoạt động';
        },
        getStatusBadge(item) {
            if (!item.room_state_id) return 'error'; // Màu cam cho MẠNG TRỐNG
            if (item.date_schedule_out) return 'warning'; // Màu vàng cho TRẢ PHÒNG
            return 'success'; // Màu xanh cho Đang hoạt động
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        formatCurrency(amount) {
            if (!amount) return '';
            return new Intl.NumberFormat('vi-VN', {
                style: 'currency',
                currency: 'VND'
            }).format(amount);
        },
        getItemKey(item) {
            return `${item.user || ''}_${item.room_id || ''}_${item.wifi_type || 'main'}`;
        },
        toggleExpandCase1And2(key) {
            if (this.expanded_case1And2.includes(key)) {
                this.expanded_case1And2 = this.expanded_case1And2.filter(k => k !== key);
            } else {
                this.expanded_case1And2.push(key);
            }
        },
        getCase1And2PairItems(item) {
            // Tìm item trong case1And2Data dựa trên user, room_id và wifi_type
            const foundItem = this.case1And2Data.find(dataItem => 
                dataItem.user === item.user && 
                dataItem.room_id === item.room_id && 
                dataItem.wifi_type === item.wifi_type
            );
            if (!foundItem || !foundItem.pair_wifis) return [];
            return foundItem.pair_wifis.filter(pair => !pair.room_state_id || pair.date_schedule_out);
        },
        exportToExcel() {
            try {
                this.loading.export = true;

                // Tạo CSV content với 3 bảng riêng biệt
                let csvContent = [];

                // Bảng 1: Cặp chính phụ có phòng báo trả phòng hoặc phòng có mạng trống
                csvContent.push('1/ CẶP CHÍNH PHỤ CÓ PHÒNG BÁO TRẢ PHÒNG HOẶC PHÒNG CÓ MẠNG TRỐNG');
                csvContent.push('');
                const headers1 = ['User', 'Phòng', 'Loại wifi', 'Tình trạng', 'Ngày trả phòng'];
                csvContent.push(headers1.join(','));

                this.processedCase1And2Data.forEach(item => {
                    const values = headers1.map(header => {
                        let value = '';
                        switch (header) {
                            case 'User': value = item.user || ''; break;
                            case 'Phòng': value = item.room_id || ''; break;
                            case 'Loại wifi': value = this.wifiTypeBadges[item.wifi_type].text || item.wifi_type; break;
                            case 'Tình trạng': value = this.getStatusText(item); break;
                            case 'Ngày trả phòng': value = item.date_schedule_out ? this.formatDate(item.date_schedule_out) : ''; break;
                        }
                        return `"${value}"`;
                    });
                    csvContent.push(values.join(','));
                });

                // Khoảng trống giữa các bảng
                csvContent.push('');
                csvContent.push('');

                // Bảng 2: Giá khác mặc định
                csvContent.push('2/ CÁC PHÒNG CÓ GIÁ THU KHÁCH HÀNG KHÁC VỚI GIÁ MẶC ĐỊNH');
                csvContent.push('');
                const headers3 = ['User', 'Phòng', 'Loại wifi', 'Giá gói cước', 'Giá thu khách hàng', 'Chênh lệch'];
                csvContent.push(headers3.join(','));

                this.case3Data.forEach(item => {
                    const values = headers3.map(header => {
                        let value = '';
                        switch (header) {
                            case 'User': value = item.user || ''; break;
                            case 'Phòng': value = item.room_id || ''; break;
                            case 'Loại wifi': value = this.wifiTypeBadges[item.wifi_type].text || item.wifi_type; break;
                            case 'Giá gói cước': value = item.price; break;
                            case 'Giá thu khách hàng': value = this.formatCurrency(item.customer_price); break;
                        }
                        return `"${value}"`;
                    });
                    csvContent.push(values.join(','));
                });

                // Download file
                const blob = new Blob([csvContent.join('\n')], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `bao-cao-bat-thuong-${new Date().toISOString().substring(0, 10)}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                swal.fire('Thành công', 'Đã xuất excel thành công', 'success');
            } catch (error) {
                console.error('Error exporting to CSV:', error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi xuất CSV', 'error');
            } finally {
                this.loading.export = false;
            }
        }
    },
    computed: {
        case1And2MainData() {
            return this.case1And2Data.map(item => {
                const hasPairProblem = item.has_pair && item.pair_wifis && 
                    item.pair_wifis.some(pair => !pair.room_state_id || pair.date_schedule_out);
                
                return {
                    user: item.user || '',
                    room_id: item.room_id || '',
                    wifi_type: item.wifi_type || 'main',
                    room_state_id: item.room_state_id,
                    date_schedule_out: item.date_schedule_out,
                    has_pair_problem: hasPairProblem,
                    pair_wifis: item.pair_wifis || []
                };
            });
        },
        processedCase1And2Data() {
            const result = [];
            const seenKeys = new Set(); // Dùng để track các item đã thêm, tránh trùng lặp
            
            this.case1And2Data.forEach(item => {
                // Tạo key để kiểm tra trùng lặp: user_room_id_wifi_type
                const mainKey = `${item.user || ''}_${item.room_id || ''}_${item.wifi_type || 'main'}`;
                
                // Thêm wifi chính/phụ có vấn đề nếu chưa có
                if (!seenKeys.has(mainKey)) {
                    result.push({
                        user: item.user || '',
                        room_id: item.room_id || '',
                        wifi_type: item.wifi_type || 'main',
                        room_state_id: item.room_state_id,
                        date_schedule_out: item.date_schedule_out
                    });
                    seenKeys.add(mainKey);
                }
                
                // Thêm các cặp wifi có vấn đề
                // Logic wifi bắt cặp:
                // - Wifi chính (main) bắt cặp với wifi phụ (auxiliary)
                // - Wifi phụ (auxiliary) bắt cặp với wifi chính (main)
                if (item.pair_wifis && item.pair_wifis.length > 0) {
                    item.pair_wifis.forEach(pair => {
                        if (!pair.room_state_id || pair.date_schedule_out) {
                            const pairWifiType = pair.wifi_type || (item.wifi_type === 'main' ? 'auxiliary' : 'main');
                            const pairKey = `${pair.user || item.user || ''}_${pair.room_id || item.room_id || ''}_${pairWifiType}`;
                            
                            // Chỉ thêm nếu chưa có item trùng (cùng user, room_id, wifi_type)
                            if (!seenKeys.has(pairKey)) {
                                result.push({
                                    user: pair.user || item.user || '',
                                    room_id: pair.room_id || item.room_id || '',
                                    wifi_type: pairWifiType,
                                    room_state_id: pair.room_state_id,
                                    date_schedule_out: pair.date_schedule_out
                                });
                                seenKeys.add(pairKey);
                            }
                        }
                    });
                }
            });
            return result;
        },
        allDataForExport() {
            const data = [];

            // Case 1 và 2 data (gộp lại)
            this.processedCase1And2Data.forEach(item => {
                data.push({
                    'User': item.user || '',
                    'Phòng': item.room_id || '',
                    'Loại wifi': this.wifiTypeBadges[item.wifi_type].text || item.wifi_type,
                    'Tình trạng': this.getStatusText(item),
                    'Ngày trả phòng': item.date_schedule_out ? this.formatDate(item.date_schedule_out) : '',
                    'Giá hiện tại': '',
                    'Giá thu khách hàng': '',
                    'Chênh lệch': '',
                    'Gói cước': '',
                    'Loại bất thường': 'Cặp chính phụ có phòng báo trả phòng hoặc phòng có mạng trống'
                });
            });

            // Case 3 data
            this.case3Data.forEach(item => {
                data.push({
                    'User': item.user || '',
                    'Phòng': item.room_id || '',
                    'Loại wifi': this.wifiTypeBadges[item.wifi_type].text || item.wifi_type,
                    'Tình trạng': '',
                    'Ngày trả phòng': '',
                    'Giá gói cước': item.price,
                    'Giá thu khách hàng': item.customer_price,
                    'Loại bất thường': 'Giá khác mặc định'
                });
            });

            return data;
        }
    }
};
</script>

<style scoped>
.auxiliary-row {
    background-color: #f5f5f5 !important;
}

.auxiliary-row td {
    padding-left: 40px !important;
}

.text-muted {
    color: #999;
    font-style: italic;
}
</style>